import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  list: [],
  pageInfo: {
    page: 1,
    totalPage: 2
  },
  condition: {
    userNo: 0,
    page: 1,
    limit: 10,
    storeNo: null,
    searchText: '',
    regDate: '',
    startDate: '',
    endDate: ''
  },
  detail: {
    couponNo:'',
    couponManageNo:'',
    issuedBy:null,
    titleKr:'',
    titleVn:'',
    discount:0,
    isPercentage:null,
    minimumUsageAmount:'',
    usageDate:'',
    startDate:'',
    endDate:'',
    isNoTimeLimit:'',
    issuableLimit:'',
    regDate:'',
    modifyDate:'',
    isActive:'',
    file:null,
    rawFile:null
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
